import axiosInstance from './AxiosInstance'

export function getExpenseTagStats(partnerId, startDate, endDate) {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  return axiosInstance.get(`partner/${partnerId}/expense-tag-stats`, { params });
}

export function getExpenseTags(partnerId, page = 1) {
  return axiosInstance.get(`partners/${partnerId}/expense-tags`, { params: { page } });
}

export function getAllExpenseTags(partnerId) {
  return axiosInstance.get(`partners/${partnerId}/expense-tags/all`);
}

export function getLatestOutboundUserWalletTransactions(userId, page = 1, perPage = null) {
  const params = { page };
  if (perPage !== null) params.per_page = perPage;
  return axiosInstance.get(`ledger/users/${userId}/payouts`, { params });
}

export function getTransactionLimitTypes() {
  return axiosInstance.get('transaction-limit-types');
}

export function setUserTransactionLimit(partnerId, userId, data) {
  return axiosInstance.post(`partners/${partnerId}/users/${userId}/set-user-transaction-limit`, data);
}

export function getUserTransactionLimits(partnerId, userId) {
  return axiosInstance.get(`partners/${partnerId}/users/${userId}/transaction-limits`);
}

export function addExpenseTag(partnerId, data) {
  return axiosInstance.post(`partners/${partnerId}/expense-tags`, data);
}

export function updateExpenseTag(partnerId, expenseTagId, data) {
  return axiosInstance.patch(`partners/${partnerId}/expense-tags/${expenseTagId}`, data);
}

export function deleteExpenseTag(partnerId, expenseTagId) {
  return axiosInstance.delete(`partners/${partnerId}/expense-tags/${expenseTagId}`);
}

export function getApprovals(partnerId, filters = {}, page = 1) {
  const params = { ...Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== '')), page }
  return axiosInstance.get(`partner/${partnerId}/approvals`, { params })
}

export function getUserReceipts(partnerId, userId, { search = '', dateFrom = '', dateTo = '', status = '', page = 1 } = {}) {
  const params = { page };
  if (search)   params.search    = search;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo)   params.date_to   = dateTo;
  if (status)   params.status    = status;
  return axiosInstance.get(`partner/${partnerId}/user/${userId}/get-user-receipts`, { params });
}

export function getTransactionsWithoutReceipts(userId) {
  return axiosInstance.get(`ledger/users/${userId}/payouts/without-receipts`);
}

export function uploadUserReceipt(partnerId, userId, data) {
  return axiosInstance.post(`ledger/partners/${partnerId}/users/${userId}/payouts/upload-receipt`, data);
}

export function getPartnerReceipts(partnerId, { search = '', dateFrom = '', dateTo = '', status = '', page = 1 } = {}) {
  const params = { page };
  if (search)   params.search    = search;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo)   params.date_to   = dateTo;
  if (status)   params.status    = status;
  return axiosInstance.get(`partner/${partnerId}/get-admin-receipts`, { params });
}

export function reviewUserReceipt(partnerId, data) {
  return axiosInstance.post(`partner/${partnerId}/approve-minipot-receipt`, data);
}

export function reviewTransactionLimitExtensionRequest(partnerId, data) {
  return axiosInstance.post(`partner/${partnerId}/respond-to-transaction-limit-extension`, data);
}

export function reviewUserWalletTopUpRequest(partnerId, data) {
  return axiosInstance.post(`partner/${partnerId}/respond-to-wallet-top-up`, data);
}

export function getLimitExtensionEligibility(partnerId, userId) {
  return axiosInstance.get(`partner/${partnerId}/user/${userId}/limit-extension-eligibility`);
}

export function getApprovalsByUser(partnerId, userId, { status = 'pending', search = '', dateFrom = '', dateTo = '', page = 1 } = {}) {
  const params = { status, page }
  if (search)   params.search    = search
  if (dateFrom) params.date_from = dateFrom
  if (dateTo)   params.date_to   = dateTo
  return axiosInstance.get(`partner/${partnerId}/user/${userId}/approvals`, { params })
}

export function cancelApprovalRequest(partnerId, approvalId) {
  return axiosInstance.delete(`partner/${partnerId}/approvals/${approvalId}`);
}

export function requestTransactionLimitExtension(partnerId, data) {
  return axiosInstance.post(`partner/${partnerId}/request-transaction-limit-extension`, data);
}

export function revertTemporaryUserTransactionLimit(partnerId, limitId) {
  return axiosInstance.post(`partner/${partnerId}/revert-temporary-user-transaction-limit`, { id: limitId });
}

export function deleteUserTransactionLimit(partnerId, limitId) {
  return axiosInstance.post(`partner/${partnerId}/delete-user-transaction-limit`, { id: limitId });
}

export function fetchReceipt(partnerId, userId, receiptId) {
  return axiosInstance.get(`partner/${partnerId}/user/${userId}/receipt/${receiptId}/view-receipt`, {
    responseType: 'blob'
  }).then(res => res.data);
}

export async function deleteReceipt(userId, receiptId) {
  const response = await axiosInstance.delete(`/user/${userId}/receipt/${receiptId}/delete-own-receipt`);
  return response.data;
}
